import * as z from 'zod';

import { paymentMethodFieldTypeSchema } from './payment-method-field-query-schema';

export const paymentMethodFieldMutationSchema = z.object({
  payment_method_id: z.number(),
  type: paymentMethodFieldTypeSchema,
  label: z.string().min(1, 'Label is required'),
  options: z.string().nullable(),
  is_required: z.boolean(),
});

export type PaymentMethodFieldMutationSchema = z.infer<typeof paymentMethodFieldMutationSchema>;
